import {Injectable, Injector} from "@angular/core";

import {BaseListService, BatchResponse} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";

import {Lookup} from "framework/services/utils.service";

@Injectable()
export class AutomationTemplatesService extends BaseListService<Models.AutomationTemplateListRequest, Models.BatchRequest, Models.Template>
{
    constructor(inj: Injector)
    {
        super(inj, Models.Template);
    }

    protected createBatchRequest(listReq: Models.AutomationTemplateListRequest,
                                 ids: string[]): Models.BatchRequest
    {
        if (!ids?.length) return Models.BatchRequest.newInstance({ids: []});
        return Models.BatchRequest.newInstance({ids: ids});
    }

    protected async getBatchResponseImpl(req: Models.BatchRequest): Promise<BatchResponse<Models.Template>>
    {
        if (!req) return null;

        const templates = await this.app.domain.apis.templates.batchTemplate(Models.TemplateBatchRequest.newInstance({ids: req.ids}));

        const lookup: Lookup<Models.Template> = {};
        for (const template of templates || [])
        {
            if (template) lookup[template.template_id] = template;
        }

        return {results: lookup};
    }

    public list(listReq: Models.AutomationTemplateListRequest): Promise<Models.ListResponse>
    {
        return this.app.domain.apis.templates.listTemplatesV2(listReq);
    }

    public getTemplateParameterSchema(tenantId: string,
                                      templateId: string): Promise<Models.TemplateGetParameterSchemaResponse>
    {
        return this.app.domain.apis.templates.getTemplateParameterSchema(tenantId, templateId);
    }

    public viewTemplateJob(tenantId: string,
                           jobId: string): Promise<Models.TemplateJobUpdateResponse>
    {
        return this.app.domain.apis.automation.viewTemplateJob(tenantId, jobId);
    }
}
